/**
 * serverClock.ts — the SERVER's clock, as the browser last heard it (R1,
 * §39.9; §38.7 item 5: "The server's date: ON the wire … as the page's
 * authority"). Every API response carries an HTTP `Date` header; the API
 * client hands it here and this module keeps the offset between that and
 * the browser clock at the moment it arrived. `serverNow()` is then the
 * browser clock corrected by that offset — the server's time, not a guess.
 *
 * Before the first response it is the browser clock, and `hasServerClock()`
 * says so. The header has one-second resolution, which is plenty for the
 * calendar days it decides.
 */
let offsetMs: number | null = null

export function noteServerDate(header: string | null | undefined, receivedAt: number = Date.now()): void {
  if (!header) return
  const t = Date.parse(header)
  if (!Number.isFinite(t)) return
  offsetMs = t - receivedAt
}

export function serverNow(): Date {
  return new Date(Date.now() + (offsetMs ?? 0))
}

export function hasServerClock(): boolean {
  return offsetMs !== null
}

/** Tests only: forget the server's clock. */
export function resetServerClock(): void {
  offsetMs = null
}
